import { FC } from 'react';

import webView from 'common/webView';
import Button, { ButtonProps } from 'components/_core/Button';

import { locales } from './locales';

export interface FooterButtonProps extends Omit<ButtonProps, 'children'> {
  children?: string;
}

const FooterButton: FC<FooterButtonProps> = ({ children, ...buttonProps }) => {
  const { isInWebView } = webView;

  const label = children ?? locales.submit;

  return (
    <Button
      icon={isInWebView ? undefined : 'arrow-right'}
      width={isInWebView ? 'full' : undefined}
      {...buttonProps}
    >
      {label}
    </Button>
  );
};

export default FooterButton;
